import { Grid, GridProps, useTheme } from "@mui/material";
import { rgba } from "polished";
import React from "react";
import styled from "styled-components";

import { prefixClassName } from "@smartrr/shared/components/primitives";
import { ICustomerPortalTheme } from "../../entities/CustomerPortalTheme";

interface Props extends GridProps {
  /**
   * The content of the component.
   */
  children?: React.ReactNode;
}

const InputWrapper = styled(Grid).attrs(() => ({
  className: prefixClassName("address-input"),
}))<{ aquariusTheme: ICustomerPortalTheme }>`
  padding-top: 0px !important;
  & input {
    background: transparent;
    border: ${props => props.aquariusTheme.modernButtonBorderWidth}px solid
      ${props => props.aquariusTheme.modernSecondaryButtonBorderColor};
    border-radius: ${props => props.aquariusTheme.modernButtonBorderRadius}px;
    height: 40px;
    padding: 10px 10px;
    width: 100%;
  }
  & input::placeholder {
    color: ${props => rgba(props.aquariusTheme.modernSecondaryButtonFontColor!, 0.5)};
  }
`;

export const AquariusInput = ({ children, ...props }: Props): JSX.Element => {
  return (
    <InputWrapper {...props} aquariusTheme={useTheme()}>
      {children}
    </InputWrapper>
  );
};
